import { Banknote } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export const PosSplitFields = ({ banks, values = {}, onChange, prefix }) => {
  const total = banks.reduce((sum, bank) => sum + (Number(values[bank.id]) || 0), 0);

  return (
    <div className="space-y-3 border-l-2 border-blue-400 pl-3" data-testid={`${prefix}-pos-split-fields`}>
      <div className="flex items-center justify-between gap-3">
        <Label className="text-sm font-medium text-foreground flex items-center gap-2">
          <Banknote className="h-4 w-4 text-blue-500" /> Dettaglio POS
        </Label>
        <span className="text-sm font-semibold text-blue-600" data-testid={`${prefix}-pos-total`}>
          Totale € {total.toFixed(2)}
        </span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {banks.map((bank) => (
          <div key={bank.id} className="space-y-1">
            <Label className="text-xs text-muted-foreground">POS {bank.nome}</Label>
            <Input
              type="number"
              min="0"
              step="0.01"
              placeholder="0.00"
              value={values[bank.id] ?? ""}
              onChange={(event) => onChange({ ...values, [bank.id]: event.target.value })}
              className="h-9 bg-card border-border text-foreground"
              data-testid={`${prefix}-pos-bank-${bank.id}-input`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};